export default __webpack_public_path__ + "static/media/07-ART-(3-3).af50e6a6.jpg";